import { Icon, useClipboard } from '@chakra-ui/react';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { FaCopy } from 'react-icons/fa6';
import { TiTick } from 'react-icons/ti';
import { useDispatch } from 'react-redux';

import { notice } from '../../redux/action/action';

const CopyIcon = ({ copyLink, fontSize } = {}) => {
  const { t } = useTranslation();
  const i18n_common = (key) => t(`common.${key}`);
  const dispatch = useDispatch();

  const { onCopy, value, setValue, hasCopied } = useClipboard('');

  const handleCopy = async () => {
    await onCopy();

    dispatch(
      notice({
        title: i18n_common('Copy Success'),
        content: '',
        type: 'success'
      })
    );
  };

  useEffect(() => {
    setValue(copyLink);
  }, [copyLink]);

  return hasCopied ? (
    <Icon
      as={TiTick}
      fontSize={fontSize || 'lg'}
      color="green.300"
      cursor="pointer"
    />
  ) : (
    <Icon
      as={FaCopy}
      fontSize={fontSize || 'lg'}
      color={'#2A749B'}
      cursor="pointer"
      onClick={handleCopy}
    />
  );
};

export default CopyIcon;
